module.exports = __webpack_public_path__ + "static/media/unlock.47ca5e05.svg";